"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactIconBase = _interopRequireDefault(require("react-icon-base"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var NettestGroupPerformance = function NettestGroupPerformance(props) {
  return _react.default.createElement(_reactIconBase.default, _extends({
    viewBox: "0 0 30 30"
  }, props), _react.default.createElement("g", null, _react.default.createElement("defs", null), _react.default.createElement("title", null, "Performance"), _react.default.createElement("g", null, _react.default.createElement("polygon", {
    points: "9.61 4.234 21.196 4.234 16.573 13.499 21.196 13.499 13.091 27.387 13.091 16.961 9.61 16.961 9.61 4.234"
  }))));
};

var _default = NettestGroupPerformance;
exports.default = _default;